<template>
  <section class="license-info">
    <a-modal
      title="License files"
      :visible="visibleFilesModal"
      :footer="null"
      :destroy-on-close="true"
      @cancel="visibleFilesModal = false"
    >
      <shift-form-attachments
        :files="license.files"
        :is-view="true"
        :with-title="false"
      />
    </a-modal>

    <section-divider title="License">
      <template v-if="hasFiles" slot="actions">
        <a-button icon="eye" @click="visibleFilesModal = true">View files</a-button>
      </template>
    </section-divider>

    <div class="license-info__grid">
      <div class="license-info__field">
        <span>Name</span>
        <strong>{{ license.name || '-' }}</strong>
      </div>
      <div class="license-info__field">
        <span>Number</span>
        <strong>{{ license.number ?? '-' }}</strong>
      </div>
      <div class="license-info__field">
        <span>Description</span>
        <strong>{{ license.description || '-' }}</strong>
      </div>
      <div class="license-info__field">
        <span>Expiration Date</span>
        <strong>{{ formatDateString(license.expiration_date) }}</strong>
      </div>
      <div class="license-info__field">
        <span>Created At</span>
        <strong>{{ formatDateString(license.created_at) }}</strong>
      </div>
    </div>
  </section>
</template>

<script>
import { Button, Modal } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment-timezone'
import ShiftFormAttachments from '@/components/form-attachments.vue'
import SectionDivider from '@/components/ui/section-divider.vue'

const { mapState: profileState } = createNamespacedHelpers('profile')

export default {
  components: {
    'a-button': Button,
    'a-modal': Modal,
    'section-divider': SectionDivider,
    'shift-form-attachments': ShiftFormAttachments
  },
  data() {
    return {
      visibleFilesModal: false
    }
  },
  computed: {
    ...profileState({
      associate: state => state.associate
    }),

    license() {
      return this.associate.license ?? {}
    },

    hasFiles() {
      return Array.isArray(this.license.files) && this.license.files.length > 0
    }
  },
  methods: {
    formatDateString(dateString) {
      return dateString ? moment(dateString).utc().format('MM/DD/YYYY') : '-'
    }
  }
}
</script>

<style scoped>
.license-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.license-info__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 8px;
}

.license-info__field {
  min-width: 0;
}

.license-info__field > span {
  display: block;
  margin-bottom: 4px;
  color: var(--text-color-secondary);
  font-size: 12px;
}

.license-info__field > strong {
  display: block;
  overflow-wrap: anywhere;
}
</style>
